/** Check local auth exist */
export const issetAuthToken = async () => {
  return localStorage.getItem("accessToken") ? true : false;
};

/** Set data */
export const setAuthToken = async (data) => {
  localStorage.setItem("accessToken", data);
  return true;
};

/** Set expiresOn */
export const setExpiresOn = async (data) => {
  localStorage.setItem("expiresOn", data);
  return true;
};

/** Get expiresOn */
export const getExpiresOn = () => {
  const expiresOn = localStorage.getItem("expiresOn");
  if (expiresOn) {
    return Number(expiresOn);
  }
  return null; // Or handle this case appropriately
};

/** Get data */
export function getAuthToken() {
  if (issetAuthToken) {
    const storageData = localStorage.getItem("accessToken");
    return storageData;
  } else {
    console.log("Cannot get from storage: Session storage no set!");
    return "";
  }
}

/** Set auth type */
export const setAuthType = async (data) => {
  localStorage.setItem("authType", data);
  return true;
};

/** Get auth type */
export const getAuthType = () => {
  const authType = localStorage.getItem("authType");
  if (authType) {
    return authType;
  }
  return null; // Or handle this case appropriately
};

/** Set company code */
export const setCompanyCode = (companycode) => {
  localStorage.setItem("companyCode", companycode);
  return true;
};

export const getCompanyCode = () => {
  const companyCode = localStorage.getItem("companyCode");
  if (companyCode) {
    return companyCode;
  }
  return null;
};

export const flushStorage = () => {
  localStorage.clear();
  return true;
};
